/* eslint-disable no-useless-constructor */
import React from "react";

export default class Alert extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div
        id="myAlert"
        className="alert alert-success alert-dismissible fade show position-fixed top-0 end-0"
        role="alert"
      >
        <strong>Parabéns!</strong> você acertou a palavras {" "}
        <strong>{this.props.palavra}!</strong>
        <button
          id="closeAlert"
          type="button"
          className="btn-close align-self-center"
          data-dismiss="alert"
          aria-label="Close"
        >
        </button>
      </div>
    );
  }
}
